/**
 *
 * CUSTOM ELEMENT
 * Auto Scroll Element will set an interval to automatically scroll the content within the x-scroll element
 *
 * Look at sections/shape-callout for the correct example of how to set the structure.
 *
 */
class AutoScrollElement extends HTMLElement {
  constructor() {
    super()
    this.interval = this.dataset?.interval ?? 2500
    this.nodes = this.dataset.nodes
    this.currentIndex = 0
    this.scrollProgressWidth = 100
  }

  init() {
    this.setInterval = setInterval(this.scrollCallback.bind(this), this.interval)
  }

  scrollCallback() {
    try {
      const element = this
      const scrollContainer = element.children[0]
      element.scrollBy({
        left: this.scrollProgressWidth,
        behavior: 'smooth',
        block: 'nearest',
        inline: 'center'
      })
      this.scrollProgressWidth += this.scrollProgressWidth
      if (this.currentIndex >= scrollContainer.children.length - 1) {
        this.currentIndex = 0
        this.scrollProgressWidth = 100

        // Scroll back to the start
        element.scrollBy({
          left: -element.scrollWidth,
          behavior: 'smooth'
        })
      } else {
        this.currentIndex = this.currentIndex + 1
      }
    } catch (err) {
      console.error(err)
    }
  }

  connectedCallback() {
    this.init()
  }

  disconnectedCallback() {
    clearInterval(this.setInterval)
  }
}

customElements.define('x-auto-scroll', AutoScrollElement)
